import { render, staticRenderFns } from "./ReportsConfig.vue?vue&type=template&id=62e968b9&scoped=true&"
import script from "./ReportsConfig.vue?vue&type=script&lang=js&"
export * from "./ReportsConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e968b9",
  null
  
)

export default component.exports